<template>
  <div class="container" v-title data-title="我的邀请记录">
    <!-- 提示视图 -->
    <div class="record-container">
      <div class="record-container-tip flex cross-center">
        <span class="record-name">昵称</span>
        <span class="record-cer-status">认证状态</span>
        <span class="record-time">注册时间</span>
      </div>
    </div>

    <!-- 列表 -->
    <div class="container-list">
      <!-- 列表 -->
      <div class="record-container-cell flex cross-center" v-for="(item, index) in invitationRecords" :key="index">
        <span class="record-name">{{item.name}}</span>
        <span class="record-cer-status" :style="{color: authenticationTextColor(item.authentication)}">{{item.authentication}}</span>
        <span class="record-time">{{item.registerTime | dateAndMinTime}}</span>
      </div>

      <div v-if="!invitationRecords || invitationRecords.length === 0" class="record-container-cell flex main-center cross-center">
        <span style="font-size: 14px; color: #999999FF;">暂无记录</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as InvitationsApi from "../../../api/Invitation.js";

export default {
  data() {
    return {
      invitationRecords: [],
    };
  },
  created() {
    this.doReqeustTeacherInvitationRecords()
  },
  methods: {
    /**
     * 查询学生邀请记录
     */
    async doReqeustTeacherInvitationRecords() {
      const invitation = await InvitationsApi.doReqeustTeacherInvitations()
      this.invitationRecords = invitation.invRecords
    },

    authenticationTextColor(val) {
        if (val === '已认证') {
            return '#21BEA1FF'
        } else if (val === '未认证') {
            return '#FF8F1FFF'
        } else {
            return 'white'
        }
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  height: 100%;
  width: 100vw;
  position: relative;

  .container-list {
    padding-top: 66px;
  }

.record-container {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    height: 66px;
    background-color: white;
  
  // 邀请记录提示框
  .record-container-tip {
    position: absolute;
    left: 16px;
    right: 16px;
    top: 16px;
    height: 34px;
    background: #e6f8f4;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    padding: 0 32px;

    span {
      color: #21bea1;
      height: 16px;
      font-size: 14px;
      font-weight: light;
      line-height: 16px;
    }
  }
  }

  

  // 邀请记录内容
  .record-container-cell {
    margin: 0 16px;
    padding: 0 32px;
    height: 44px;
    background: #ffffff;
    box-shadow: inset 0px -1px 0px 0px #eeeeee;
    opacity: 1;

    span {
      color: #333333ff;
      height: 16px;
      font-size: 14px;
      font-weight: light;
      line-height: 16px;
    }
  }

  .record-name {
      width: 30%;
      overflow: hidden; /*超出部分隐藏*/
      text-overflow: ellipsis; /*超出部分省略号表示*/
      white-space: nowrap; /*强制单行显示*/
    }

    .record-cer-status {
      width: 30%;
      white-space: nowrap; /*强制单行显示*/
    }
    
    .record-time {
      width: 35%;
      white-space: nowrap; /*强制单行显示*/
    }
}
</style>


// WEBPACK FOOTER //
// src/views/invitation/teacher/InvitationTeacherRecord.vue